export default __webpack_public_path__ + "static/media/office-chat.0743fb99.webp";